<template>
  <div class="w-100 h-100 f-c-c f-d-c">
    <b-spinner
      v-if="isLoader"
      variant="primary"
      type="grow"
      label="Spinning"
      class="mb-3"
    ></b-spinner>
    <div>{{message}}</div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Loginas",
  data() {
    return {
      isLoader: true,
      message:'لطفا کمی صبر کنید ...'
    };
  },
  created() {
    this.directLoginFunction({
      token: this.$route.params.id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
    }),
  },
  methods: {
    ...mapActions("gap", ["directLoginFunction"]),
  },
  watch: {
    user(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
            this.$router.push({ name: "myMeets" });
        } else {
            this.message = n.message
        }
      }
    },
  },
  mounted() {},
};
</script>
